import { OverviewComponent } from "../components";
import { usePreview } from "./usePreview";

const Preview = (): JSX.Element => {
  const {
    isLoading,
    projectDetails,
    // stackedChartData,
    // xAxisLabels,
    tags,
    badges,
    certifications,
    standardSpecificDefinition,
  } = usePreview();
  return (
    <div>
      {!isLoading && standardSpecificDefinition && (
        <OverviewComponent
          projectDetails={projectDetails}
          // stackedChartData={stackedChartData}
          // xAxisLabels={xAxisLabels}
          tags={tags}
          badges={badges}
          certifications={certifications}
          isPreview
          standardSpecificDefinition={standardSpecificDefinition}
        />
      )}
    </div>
  );
};

export default Preview;
